import React from "react";

import { Card, Button, CardTitle, CardText } from "reactstrap";

import { withRouter } from "react-router";

import { inject } from "mobx-react";

import styled, { withTheme } from "styled-components";

import locales from "../utils/locales";

import timestamp from "../utils/timestamp";

import LocaleSwitcher from "./LocaleSwitcher";

const Wrapper = styled.div`
  width: 100%;
  max-width: 300px;
  height: 100%;

  position: absolute;

  top: 0;
  right: 0;

  padding-top: ${props => props.theme.sizes.baseSpace * 2}px;

  &:after {
    content: "";
    width: 100%;
    background-repeat: no-repeat;
    background-size: contain;

    position: absolute;
    left: 0;
    right: 0;

    z-index: 3;
    height: 50vh;
    background-image: url(./assets/images/tito-teo.png?${timestamp});
    background-position: right bottom;
    bottom: 25px;
  }

  @media (orientation: portrait) {
    display: none;
  }
`;

const StyledCard = styled(Card)`
  font-family: "Patrick Hand", cursive;
  border: none !important;
  background-color: transparent !important;
  background-image: url(./assets/images/box.png?${timestamp});
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding: 5px 1.5rem;
`;

const StyledCardTitle = styled(CardTitle)`
  text-align: center;
  text-transform: uppercase;
  font-weight: regular;
  color: ${props => props.theme.palette.blue};
  font-size: 1.25em;
  margin-top: 0.5rem;
`;

const StyledCardText = styled(CardText)`
  font-family: "Source Sans Pro", sans-serif;
  font-size: 0.9em;
  line-height: 1.05rem;
  color: ${props => props.theme.palette.blue};
  flex-direction: row;
  display: flex;
  align-items: center;
  margin-bottom: 0;

  img {
    display: inline-block;
    height: 50px;
    width: 50px;
    margin-right: 15px;
  }
`;

const StyledPlay = styled.a.attrs({
  target: "_BLANK"
})`
  font-family: "Patrick Hand", cursive;
  font-size: 1em;
  line-height: 1.05rem;
  color: ${props => props.theme.palette.blue};
  flex-direction: row;
  display: flex;
  align-items: center;
  margin-bottom: 0;
  padding-top: 1em;

  .icon {
    background-image: url(./assets/images/play-icon.png?${timestamp});
    background-position: 0 0%;
    background-repeat: no-repeat;
    display: inline-block;
    height: 40px;
    width: 40px;
    min-width: 40px;
    margin-right: 10px;
    background-size: 80px 100%;
  }

  &:hover,
  &:active {
    color: ${props => props.theme.palette.orange};
    text-decoration: none;
    .icon {
      background-position: -40px 0%;
    }
  }
`;

const StyledButton = styled(Button)`
  text-align: center;
  text-transform: uppercase;
  font-weight: regular;
  background: transparent !important;
  margin: ${props => props.theme.sizes.baseSpace}px;
  margin-top: ${props => props.theme.sizes.baseSpace / 2}px;
  color: ${props => props.theme.palette.orange} !important;
  border: none !important;

  margin-bottom: 0;
  margin-top: 0;
  font-size: 1.25em !important;
  padding-top: 0 !important;

  &:hover,
  &:active,
  &:focus,
  &:visited {
    color: ${props => props.theme.palette.orange} !important;
    background: transparent !important;
    outline: none !important;
    border: none !important;
  }

  img {
    display: inline-block;
    height: 1em;
    padding-right: 0.5rem;
  }
`;

const mapper = (stores, props) => ({
  intl: locales[props.match.params.locale || stores.uiStore.getLocale.get()]
});

export default withRouter(
  withTheme(
    inject(mapper)(({ intl }) => (
      <Wrapper>
        <LocaleSwitcher />
        <StyledCard>
          <StyledCardTitle>{intl.DOWNLOAD_TITLE}</StyledCardTitle>
          <StyledCardText>
            <img src={`./assets/images/icon.png?${timestamp}`} />
            {intl.DOWNLOAD_TEXT}
          </StyledCardText>
          <StyledButton href={`${intl.PDF_LINK}?${timestamp}`} target="_BLANK">
            <img src={`./assets/images/icon-download.png?${timestamp}`} />
            {intl.DOWNLOAD_BUTTON}
          </StyledButton>
        </StyledCard>
        <StyledPlay href={intl.VIDEO_LINK || "/"}>
          <div className="icon" />
          {intl.PLAY_TEXT}
        </StyledPlay>
      </Wrapper>
    ))
  )
);



// WEBPACK FOOTER //
// ./src/components/Download.js